import Clipboard from 'clipboard';

export class Controller {

    /** @ngInject */
    constructor($rootScope, $scope, $state, $http, $translate, Alert, IdpAuthenticatorsService, DestructiveOperationModal, ConfirmModal) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.$http = $http;
        this.$translate = $translate;
        this.Alert = Alert;
        this.IdpAuthenticatorsService = IdpAuthenticatorsService;
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.ConfirmModal = ConfirmModal;
    }

    $onInit() {
        if(this.idpAuthenticator == null) {
            this.$state.go('company.idp-authenticators.list');
            return;
        }
        this.$idpAuthenticator = angular.copy(this.idpAuthenticator);
        this.isOidc = this.idpAuthenticator.type === 'OIDC';
        this.isSaml = this.idpAuthenticator.type === 'SAML';

        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(() => {
            this.Alert('success', 'global.data_copied')
            })
        })
    }

    isMetadataUrlValid() {
        let metadataUrl = this.metadataUrl;
        return metadataUrl && this.$rootScope.webPattern.test(metadataUrl)
    }

    metadataFileChanged() {
        if (this.metadataFile.size > 500000) {
            this.Alert('danger', 'Metadata XML file should be smaller than 500 KB');
            this.metadataFile = null;
        }
    }

    saveMetadataUrl() {
        this.isSaving = true;
        let messageKey = this.$translate('company.manage-application.configuration.upload-metadata.confirm.message', { metadataXml: 'METADATA URL' })
        let titleKey = this.$translate('company.manage-application.configuration.upload-metadata.confirm.title', { metadataXml: 'METADATA URL' })
        this.ConfirmModal({
            messageKey: messageKey,
            titleKey: titleKey
        })
            .then(() =>
                this.saveMetadata(this.metadataUrl, null)
            )
            .finally(() => (this.isSaving = false));
    }

    saveMetadataFile() {
        this.isSaving = true;
        let messageKey = this.$translate('company.manage-application.configuration.upload-metadata.confirm.message', { metadataXml: 'METADATA XML' })
        let titleKey = this.$translate('company.manage-application.configuration.upload-metadata.confirm.title', { metadataXml: 'METADATA XML' })
        this.ConfirmModal({
            messageKey: messageKey,
            titleKey: titleKey
        })
            .then(() =>
                this.saveMetadata(null, this.metadataFile)
            )
            .finally(() => (this.isSaving = false));
    }

    saveMetadata(metadataUrl, metadataFile) {
        let ctrl = this;
        if (metadataUrl != null && metadataUrl.length > 0) {
            this.uploadMetadataUrl(metadataUrl);
        } else if (metadataFile != null) {
            var reader = new FileReader();
            reader.onload = function () {
                ctrl.uploadMetadataXml(reader.result);
            };
            if(metadataFile) {
                reader.readAsText(metadataFile);
            }
        }
    }

    uploadMetadataXml(metadataStr) {
        this.IdpAuthenticatorsService.uploadMetadataXml(this.companyId, this.idpAuthenticator.id, metadataStr)
            .then(()=> {
                this.Alert('success', 'company.idp-authenticators.manage.config.updated');
                this.$state.reload('company.idp-authenticators');
        })
    }

    uploadMetadataUrl(metadataUrl) {
        this.IdpAuthenticatorsService.uploadMetadataUrl(this.companyId, this.idpAuthenticator.id, metadataUrl)
            .then(()=> {
                this.Alert('success', 'company.idp-authenticators.manage.config.updated');
                this.$state.reload('company.idp-authenticators');
        })
    }

    save() {
        this.isSaving = true;
        this.IdpAuthenticatorsService
            .updateIdpAuthenticator(this.companyId, this.idpAuthenticator)
            .then((idpAuthenticator) => {
                this.idpAuthenticator = angular.copy(idpAuthenticator);
                this.$idpAuthenticator = angular.copy(idpAuthenticator);
                this.Alert('success', 'company.idp-authenticators.manage.config.updated');
            })
            .finally(() => this.isSaving = false)
    }

    notModified() {
        return angular.equals(this.$idpAuthenticator, this.idpAuthenticator);
    }

    discardChanges() {
        this.idpAuthenticator = angular.copy(this.$idpAuthenticator);
    }

    delete() {
        this.isSaving = true
        this.DestructiveOperationModal({
            titleKey: 'global.confirm_delete',
            textKey: 'company.idp-authenticators.confirm_delete.text',
            onSubmit: params => this.IdpAuthenticatorsService
                .deleteIdpAuthenticator(this.companyId, this.idpAuthenticator.id, params)
                .then(() => {
                    this.Alert('success', 'company.idp-authenticators.removed');
                    this.$state.go('company.idp-authenticators.list', {}, {reload: true});
            })
        })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/manage/config/idp-authenticator-config.controller.js